import {
  ProfileModel,
  StatusModel,
  SkillModel,
  OtherModel,
  BackStoryModel,
  CharactersheetsModel,
  JobPointFormula,
} from '@/model/charactersheets';

export const mutations = {
  setGameSystem: (state: CharactersheetsModel, payload: number) => {
    state.gamesystem = payload;
  },
  setProfile: (state: CharactersheetsModel, payload: ProfileModel) => {
    state.profile = payload;
  },
  setStatus: (state: CharactersheetsModel, payload: StatusModel) => {
    const skillInitialSet = (skills: SkillModel[]) => {
      skills.forEach(skill => {
        if (skill.label === '回避') {
          skill.initial = (payload.dex.default + payload.dex.correction) * 2;
          skill.totalpoint = skill.initial + skill.jobpoint + skill.interestpoint + skill.otherpoint;
        } else if (skill.label === '母国語') {
          skill.initial = (payload.edu.default + payload.edu.correction) * 5;
          skill.totalpoint = skill.initial + skill.jobpoint + skill.interestpoint + skill.otherpoint;
        }
      });
    };
    state.status = payload;

    if (state.skill) {
      skillInitialSet(state.skill);
    }

    if (state.skillList) {
      skillInitialSet(state.skillList);
    }
  },
  addedSkill: (state: CharactersheetsModel, payload: SkillModel) => {
    state.skill.push(payload);
  },
  setSkill: (state: CharactersheetsModel, payload: SkillModel[]) => {
    state.skill = payload;
  },
  setOther: (state: CharactersheetsModel, payload: OtherModel) => {
    state.other = payload;
  },
  setBackStory: (state: CharactersheetsModel, payload: BackStoryModel) => {
    state.backStory = payload;
  },
  setUid: (state: CharactersheetsModel, payload: string) => {
    state.uid = payload;
  },
  setPrivate: (state: CharactersheetsModel, payload: boolean) => {
    state.isPrivate = payload;
  },
  setSkillList: (state: CharactersheetsModel, payload: SkillModel[]) => {
    state.skillList = payload;
  },
  setJobPointFormula: (state: CharactersheetsModel, payload: JobPointFormula) => {
    state.jobPointFormula = payload;
  },
};
